(() => {
  'use strict';
  if (window.LisaHomeQuickCartLoaded) return;
  window.LisaHomeQuickCartLoaded = true;

  const homeSelector = '.merchandise-first__action[data-lisa-home-add]';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cartEndpoint = root + 'cart/add.js';
  const cartJsonEndpoint = root + 'cart.js';
  const getProductCache = new Map();
  let dialog;
  let dialogReturnFocus;
  let notice;
  let noticeTimeout;
  let cartReadId = 0;
  let cartCounts = new Map();

  function updateProductBadges(cart) {
    cartCounts = new Map();
    for (const item of cart.items || []) {
      const id = String(item.product_id);
      cartCounts.set(id, (cartCounts.get(id) || 0) + Number(item.quantity || 0));
    }
    renderProductBadges();
  }

  function renderProductBadges() {
    document.querySelectorAll(homeSelector).forEach(link => {
      const card = link.closest('.merchandise-first__item, .grid__item')?.querySelector('[data-lisa-product-id]');
      const count = cartCounts.get(card?.dataset.lisaProductId) || 0;
      let badge = link.querySelector('.lisa-button-cart-count');
      let label = link.querySelector('.lisa-button-cart-count-label');
      if (!count) {
        badge?.remove();
        label?.remove();
        return;
      }
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'lisa-button-cart-count';
        badge.setAttribute('aria-hidden', 'true');
        link.appendChild(badge);
      }
      if (!label) {
        label = document.createElement('span');
        label.className = 'visually-hidden lisa-button-cart-count-label';
        link.appendChild(label);
      }
      const value = String(count);
      if (badge.textContent !== value) badge.textContent = value;
      const description = (link.dataset.lisaCartCountLabel || '[count]').replace('[count]', value);
      if (label.textContent !== description) label.textContent = description;
    });
  }

  function notify(message, error = false) {
    if (!notice) {
      notice = document.createElement('div');
      notice.className = 'lisa-home-cart-notice';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      notice.hidden = true;
      document.body.appendChild(notice);
    }
    if (noticeTimeout) clearTimeout(noticeTimeout);
    notice.replaceChildren();
    const messageElement = document.createElement('span');
    messageElement.textContent = message;
    notice.appendChild(messageElement);
    if (!error) {
      const cartLink = document.createElement('a');
      cartLink.href = root + 'cart';
      cartLink.textContent = window.LisaI18n.view_cart;
      notice.appendChild(cartLink);
    }
    notice.classList.toggle('lisa-home-cart-notice--error', error);
    notice.hidden = false;
    noticeTimeout = setTimeout(() => { notice.hidden = true; }, 6500);
  }

  function productAjaxUrl(productHref) {
    const url = new URL(productHref, location.href);
    if (url.origin !== location.origin) throw new Error(window.LisaI18n.invalid_address);
    const match = url.pathname.match(/^(.*?)(?:\/collections\/[^/]+)?\/products\/([^/]+)\/?$/);
    if (!match) throw new Error(window.LisaI18n.load_error);
    return location.origin + match[1] + '/products/' + encodeURIComponent(decodeURIComponent(match[2])) + '.js';
  }

  async function fetchProduct(productHref) {
    const url = productAjaxUrl(productHref);
    if (!getProductCache.has(url)) {
      const request = fetch(url, {credentials: 'same-origin', headers: {'Accept': 'application/json'}})
        .then(async response => {
          if (!response.ok) throw new Error(window.LisaI18n.load_error);
          const data = await response.json();
          if (!Array.isArray(data.variants) || !data.variants.length) throw new Error(window.LisaI18n.choices_error);
          return data;
        }).catch(error => { getProductCache.delete(url); throw error; });
      getProductCache.set(url, request);
    }
    return getProductCache.get(url);
  }

  function createDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'lisa-home-cart-dialog';
    dialog.setAttribute('aria-labelledby', 'LisaHomeCartTitle');
    dialog.innerHTML = [
      '<div class="lisa-home-cart-dialog__heading">',
      '<h2 id="LisaHomeCartTitle"></h2>',
      '<button type="button" class="lisa-home-cart-dialog__close" aria-label="Close">×</button>',
      '</div>',
      '<form class="lisa-home-cart-dialog__form">',
      '<img class="lisa-home-cart-dialog__image" alt="" hidden>',
      '<div class="lisa-home-cart-dialog__options"></div>',
      '<p class="lisa-home-cart-dialog__price"></p>',
      '<label class="lisa-home-cart-dialog__quantity">Quantity',
      '<input name="quantity" type="number" min="1" step="1" value="1" inputmode="numeric" required>',
      '</label>',
      '<p class="lisa-home-cart-dialog__error" role="alert" hidden></p>',
      '<button type="submit" class="lisa-home-cart-dialog__add">Add to cart</button>',
      '</form>'
    ].join('');
    dialog.querySelector('.lisa-home-cart-dialog__close').setAttribute('aria-label', window.LisaI18n.close);
    dialog.querySelector('.lisa-home-cart-dialog__quantity').firstChild.textContent = window.LisaI18n.quantity;
    dialog.querySelector('.lisa-home-cart-dialog__add').textContent = window.LisaI18n.add;
    document.body.appendChild(dialog);
    dialog.querySelector('.lisa-home-cart-dialog__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (dialogReturnFocus?.isConnected) dialogReturnFocus.focus();
      dialogReturnFocus = null;
    });
    return dialog;
  }

  function optionData(product) {
    const variants = product.variants || [];
    return (product.options || []).map((option, index) => {
      const name = typeof option === 'string' ? option : option.name;
      const values = (typeof option === 'object' && Array.isArray(option.values))
        ? option.values.map(value => typeof value === 'string' ? value : value.name)
        : [...new Set(variants.map(v => (v.options || [])[index] || v['option' + (index + 1)]).filter(Boolean))];
      return {name: name || window.LisaI18n.option + (index + 1), values};
    });
  }

  function valueAt(variant, i) {
    return (Array.isArray(variant.options) && variant.options[i]) || variant['option' + (i + 1)] || '';
  }

  function directAddVariant(product, picker) {
    const variants = product.variants;
    const selected = variants.find(variant => String(variant.id) === String(picker?.selectedVariantId));
    if (picker?.dataset.singleColors === 'true') return selected || null;
    if (variants.length === 1) return variants[0];

    let candidates = variants;
    if (variants.some(variant => (variant.sku || '').endsWith('-BULK144'))) {
      candidates = variants.filter(variant => !(variant.sku || '').endsWith('-BULK144'));
      if (picker?.hasAttribute('data-sock-selector')) {
        if (!selected) return null;
        candidates = candidates.filter(variant => valueAt(variant, 0) === valueAt(selected, 0));
      }
    } else if (variants.some(variant => (variant.sku || '').includes('-SINGLE-'))) {
      candidates = variants.filter(variant => (variant.sku || '').includes('-SINGLE-'));
    }
    return candidates.length === 1 ? candidates[0] : null;
  }

  function formatPrice(price) {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency}).format(Number(price) / 100); }
    catch { return (Number(price) / 100).toFixed(2); }
  }

  function showProductPicker(product, trigger) {
    const popup = createDialog();
    const previous = popup.querySelector('form');
    // Replacing the form prevents event handlers from an earlier product picker persisting.
    const form = previous.cloneNode(true);
    previous.replaceWith(form);
    const controls = form.querySelector('.lisa-home-cart-dialog__options');
    const qty = form.querySelector('[name="quantity"]');
    const errorLabel = form.querySelector('.lisa-home-cart-dialog__error');
    const addButton = form.querySelector('.lisa-home-cart-dialog__add');
    const priceLabel = form.querySelector('.lisa-home-cart-dialog__price');
    const image = form.querySelector('.lisa-home-cart-dialog__image');
    popup.querySelector('#LisaHomeCartTitle').textContent = product.title || window.LisaI18n.choose;
    controls.replaceChildren();
    qty.value = '1';
    errorLabel.hidden = true;
    errorLabel.textContent = '';
    addButton.textContent = window.LisaI18n.add;

    const saleNode = trigger.closest('.merchandise-first__item, .grid__item')?.querySelector('[data-lisa-sale-product]');
    const saleProduct = saleNode ? JSON.parse(saleNode.textContent) : null;
    const cardColorPicker = trigger.closest('.merchandise-first__item, .grid__item')?.querySelector('lisa-card-colors');
    const cardColorId = cardColorPicker?.selectedVariantId;
    const colorOnly = (product.tags || []).includes('Color Swatches');
    const useCardSelection = colorOnly || cardColorPicker?.hasAttribute('data-sock-selector');
    const initial = (useCardSelection && product.variants.find(v => String(v.id) === String(cardColorId) && v.available)) || product.variants.find(variant => variant.available && (variant.sku || '').includes('-SINGLE-')) || product.variants.find(variant => variant.available) || product.variants[0];
    const selects = [];
    optionData(product).forEach((option, index) => {
      const isColor = colorOnly && /^(color|colors|colour|colours|colores)$/i.test(option.name);
      const wrapper = document.createElement(isColor ? 'fieldset' : 'label');
      wrapper.className = 'lisa-home-cart-dialog__option';
      const title = document.createElement(isColor ? 'legend' : 'span');
      title.textContent = option.name;
      wrapper.appendChild(title);
      const select = document.createElement('select');
      select.required = true;
      option.values.forEach(value => {
        const item = document.createElement('option');
        item.value = value;
        item.textContent = value;
        select.appendChild(item);
      });
      select.value = valueAt(initial, index);
      wrapper.appendChild(select);
      if (isColor) {
        wrapper.classList.add('lisa-color-only-group');
        select.hidden = true;
        const swatches = document.createElement('div');
        swatches.className = 'lisa-beanie__swatches';
        option.values.forEach(value => {
          const label = document.createElement('label');
          label.className = 'lisa-beanie__swatch'; label.title = value;
          const radio = document.createElement('input');
          radio.type = 'radio'; radio.name = 'lisa-quick-color-' + index;
          radio.value = value; radio.checked = select.value === value;
          radio.setAttribute('aria-label', value);
          const chip = document.createElement('span');
          chip.className = 'lisa-beanie__chip'; chip.setAttribute('aria-hidden', 'true');
          window.LisaPaintColorSwatch?.(chip, value);
          radio.addEventListener('change', () => {
            if (!radio.checked) return;
            select.value = value; title.textContent = option.name + ': ' + value;
            select.dispatchEvent(new Event('change', {bubbles:true}));
          });
          label.append(radio,chip); swatches.appendChild(label);
        });
        title.textContent = option.name + ': ' + select.value;
        wrapper.appendChild(swatches);
      }
      controls.appendChild(wrapper);
      selects.push(select);
    });

    function selectedVariant() {
      return product.variants.find(variant => selects.every((select, index) => valueAt(variant, index) === select.value));
    }
    function refreshPrice() {
      const variant = selectedVariant();
      if (variant?.available && window.LisaSales) window.LisaSales.renderPrice(priceLabel, saleProduct, variant);
      else {
        delete priceLabel.dataset.lisaPriceSignature;
        priceLabel.classList.remove('lisa-choice-price--sale');
        priceLabel.textContent = variant ? formatPrice(variant.price) + (variant.available ? '' : window.LisaI18n.sold_suffix) : window.LisaI18n.combination;
      }
    }
    function refresh() {
      const variant = selectedVariant();
      const available = Boolean(variant && variant.available);
      refreshPrice();
      addButton.disabled = !available;
      addButton.textContent = available ? window.LisaI18n.add : window.LisaI18n.unavailable;
      errorLabel.hidden = true;
      const assortedSocks = product.variants.some(v => (v.sku || '').endsWith('-BULK144')) && variant?.options?.some(value => /assort|surtid/i.test(value));
      const photo = assortedSocks ? null : variant?.featured_image?.src || product.image?.src || product.featured_image;
      const photoUrl = typeof photo === 'string' ? photo : photo?.src;
      if (photoUrl && /^https?:\/\//.test(photoUrl)) {
        image.src = photoUrl;
        image.alt = (product.title || window.LisaI18n.product) + ' – ' + (variant?.title || window.LisaI18n.selected_option);
        image.hidden = false;
      } else {
        image.hidden = true;
        image.removeAttribute('src');
      }
    }
    if (product.variants.some(v => (v.sku || '').endsWith('-BULK144'))) {
      const picker = document.createElement('lisa-sock-picker');
      const native = document.createElement('div');
      native.dataset.sockNative = '';
      while (controls.firstChild) native.appendChild(controls.firstChild);
      const data = document.createElement('script');
      data.type = 'application/json'; data.dataset.sockVariants = '';
      data.textContent = JSON.stringify(product.variants);
      picker.append(native,data);
      controls.appendChild(picker);
    } else if ([7379913081021,7381805990077].includes(Number(product.id))) {
      const picker = document.createElement('lisa-thermal-picker');
      const native = document.createElement('div');
      native.dataset.thermalNative = '';
      while (controls.firstChild) native.appendChild(controls.firstChild);
      const data = document.createElement('script');
      data.type = 'application/json'; data.dataset.thermalVariants = '';
      data.textContent = JSON.stringify(product.variants);
      picker.saleProduct = saleProduct;
      picker.append(native,data);
      controls.appendChild(picker);
    } else if ([15502007926973, 15474236195005, 15470312358077, 15463475052733, 15463428260029, 15463386742973, 15462379323581, 15462289473725, 15462318768317].includes(Number(product.id)) || (product.tags || []).includes('Winter Sets') || Number(product.id) === 15449947603133 || Number(product.id) === 15449859391677 || [15449950748861, 7389940318397].includes(Number(product.id)) || [7185005084861,7185025466557,7185036705981,7185040146621].includes(Number(product.id)) || [15446140682429, 15446184067261, 15446211002557, 15473175691453, 15473648992445].includes(Number(product.id)) || (product.tags || []).includes('Manicure Sets') || (product.tags || []).includes('Bracelets') || Number(product.id) === 15442357321917 || Number(product.id) === 7184995745981 || (([15438719353021, 15438710898877, 15433030402237, 15433215049917, 15428651909309, 15430982402237, 7379917242557, 7389941366973, 7389941825725, 15430984892605, 7381819228349, 15419207123133, 7379916259517, 7379914621117, 15419207155901, 7393495154877, 7385596723389, 7382781132989, 7393487290557, 7393491943613].includes(Number(product.id)) || product.variants.some(v => /^(?:SQUISH-[A-Z]+-|CORD-\d+-|WT-(HAT|PAIR|SCARF|HOOD)-)/.test(v.sku || ''))) && product.variants.some(v => /^(SQUISH-[A-Z]+|CAP-(?:FAITH|EAGLE|RACK|WOODLAND)|CORD-\d+|AA296|RHIN-POM|GLOVE-CLOTH|GLOVE-WOMEN|GLOVE-INSULATED|EARMUFF-PLUSH|TRAPPER-MASK|BEANIE-INSULATED|FACE-MASK|NINJA-MASK|BEANIE-AWARENESS|POM-DESIGN|CITY-BEANIE|SKI-MASK|SCARF-INFINITY|SCARF-BRAIDED|WT-(?:HAT|PAIR|SCARF|HOOD)-\d+)-SINGLE-/.test(v.sku || '')))) {
      const picker = document.createElement([7393495154877, 7385596723389, 7382781132989].includes(Number(product.id)) ? 'lisa-pom-picker' : 'lisa-beanie-picker');
      if (Number(product.id) === 15474236195005) { picker.dataset.earmuffs = ''; picker.dataset.colorCircles = ''; }
      if (Number(product.id) === 15470312358077) picker.dataset.cords = '';
      if (Number(product.id) === 15463475052733) picker.dataset.boxerBriefs = '';
      if (Number(product.id) === 15463428260029) { picker.dataset.athleticShirts = ''; picker.dataset.colorCircles = ''; }
      if (Number(product.id) === 15462379323581) picker.dataset.tshirts = '';
      if (Number(product.id) === 15462289473725) picker.dataset.thermalSocks = '';
      if (Number(product.id) === 15462318768317) { picker.dataset.reindeerSocks = ''; picker.dataset.colorCircles = ''; }
      if ([15446140682429, 15446184067261, 15446211002557, 15473175691453, 15473648992445].includes(Number(product.id))) picker.dataset.assortedCaps = '';
      if ([15449859391677,15449947603133].includes(Number(product.id))) picker.dataset.characterHats = '';
      if (Number(product.id) === 15463386742973) { picker.dataset.catBeanies = ''; picker.dataset.colorCircles = ''; }
      if (Number(product.id) === 15449947603133) picker.dataset.earflapHats = '';
      if ([15451338997949, 15451339063485, 15451896774845, 15449947603133].includes(Number(product.id))) picker.dataset.colorCircles = '';
      if ([15449950748861, 7389940318397].includes(Number(product.id))) picker.dataset.touchGloves = '';
      if ((product.tags || []).includes('Winter Sets')) picker.dataset.winterSets = '';
      if ((product.tags || []).includes('Bracelets')) picker.dataset.bracelets = '';
      if (Number(product.id) === 15502007926973) picker.dataset.necklaces = '';
      if ((product.tags || []).includes('Manicure Sets')) picker.dataset.manicure = '';
      const native = document.createElement('div');
      native.dataset.beanieNative = '';
      while (controls.firstChild) native.appendChild(controls.firstChild);
      const data = document.createElement('script');
      data.type = 'application/json';
      data.dataset.beanieVariants = '';
      data.textContent = JSON.stringify(product.variants);
      picker.saleProduct = saleProduct;
      picker.append(native, data);
      controls.appendChild(picker);
    }
    controls.addEventListener('change', refresh);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const variant = selectedVariant();
      const quantity = Number(qty.value);
      if (!variant?.available || !Number.isSafeInteger(quantity) || quantity < 1) {
        errorLabel.textContent = window.LisaI18n.select_valid;
        errorLabel.hidden = false;
        return;
      }
      addButton.disabled = true;
      addButton.textContent = window.LisaI18n.adding;
      try {
        await addVariant(variant.id, quantity, dialogReturnFocus);
        popup.close();
        notify(window.LisaI18n.added);
      } catch (error) {
        errorLabel.textContent = error.message || window.LisaI18n.add_error;
        errorLabel.hidden = false;
      } finally {
        refresh();
      }
    });
    refresh();
    dialogReturnFocus = trigger;
    popup.showModal();
    window.LisaSales?.watch(form, () => { if (popup.open) refreshPrice(); });
  }

  async function updateCartBubble() {
    const requestId = ++cartReadId;
    const response = await fetch(cartJsonEndpoint, {credentials: 'same-origin', cache: 'no-store', headers: {'Accept': 'application/json'}});
    if (!response.ok) return;
    const cart = await response.json();
    if (requestId !== cartReadId) return;
    updateProductBadges(cart);
    const icon = document.querySelector('#cart-icon-bubble');
    if (!icon) return;
    const count = Number(cart.item_count) || 0;
    let bubble = icon.querySelector('.cart-count-bubble');
    if (!count) {
      if (bubble) bubble.remove();
      return;
    }
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      icon.appendChild(bubble);
    }
    bubble.replaceChildren();
    if (count < 100) {
      const number = document.createElement('span');
      number.setAttribute('aria-hidden', 'true');
      number.textContent = String(count);
      bubble.appendChild(number);
    }
    const visuallyHidden = document.createElement('span');
    visuallyHidden.className = 'visually-hidden';
    visuallyHidden.textContent = count + (count === 1 ? window.LisaI18n.item_count : window.LisaI18n.items_count);
    bubble.appendChild(visuallyHidden);
  }

  async function addVariant(variantId, quantity, trigger) {
    const response = await fetch(cartEndpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({id: variantId, quantity})
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.description || error.message || window.LisaI18n.item_error);
    }
    await updateCartBubble().catch(() => {});
    document.dispatchEvent(new CustomEvent('lisa:cart-added', { detail: { trigger } }));
  }

  const refreshCart = () => { updateCartBubble().catch(() => {}); };
  refreshCart();
  window.addEventListener('pageshow', event => { if (event.persisted) refreshCart(); });
  window.addEventListener('focus', refreshCart);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refreshCart();
  });
  const main = document.getElementById('MainContent');
  if (main) {
    let badgeUpdateQueued = false;
    new MutationObserver(records => {
      const addedCards = records.some(record => [...record.addedNodes].some(node =>
        node.nodeType === 1 && (node.matches(homeSelector) || node.querySelector(homeSelector))
      ));
      if (!addedCards || badgeUpdateQueued) return;
      badgeUpdateQueued = true;
      requestAnimationFrame(() => { badgeUpdateQueued = false; renderProductBadges(); });
    }).observe(main, { childList: true, subtree: true });
  }

  document.addEventListener('click', async event => {
    const link = event.target.closest?.(homeSelector);
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy', 'true');
    try {
      const product = await fetchProduct(link.href);
      if (product.requires_selling_plan) {
        location.assign(link.href);
        return;
      }
      const colorPicker = link.closest('.merchandise-first__item, .grid__item')?.querySelector('lisa-card-colors');
      const variant = directAddVariant(product, colorPicker);
      if (variant) {
        if (!variant.available) {
          notify(window.LisaI18n.sold_notice, true);
        } else {
          await addVariant(variant.id, 1, link);
          notify(window.LisaI18n.added);
        }
      } else if (typeof HTMLDialogElement === 'undefined' || typeof HTMLDialogElement.prototype.showModal !== 'function') {
        location.assign(link.href);
      } else {
        showProductPicker(product, link);
      }
    } catch (error) {
      notify((error && error.message) || window.LisaI18n.open_product, true);
    } finally {
      link.removeAttribute('aria-busy');
    }
  });
})();










